module.exports = __webpack_public_path__ + "img/default_hero_org.58f43ed4.png";